import type { ConstValues } from '@openx/types/helpers';

type AllowedOrganizationsFee = string | null;

export const revenueMethodValues = {
  PoM: 'PoM',
  CPM: 'CPM',
} as const;

export type RevenueMethod = ConstValues<typeof revenueMethodValues>;

type Recipient = {
  id: string;
  uid?: string;
  name: string;
};

export type AudienceSharesByFee = {
  fee: AllowedOrganizationsFee;
  revenueMethod: RevenueMethod;
  recipients: Recipient[];
  shareId?: string;
  uids?: string[] | null;
};

export type AudienceShare = {
  recipient_account_name: string;
  recipient_account_id: string;
  uid: string;
  revenue_method: RevenueMethod;
  third_party_revenue: string | null;
  cpm_cap: string | null;
  id: string;
};
